const mod = crateImports["@xing-com/crate-layout-scroll-memo-module"];
const { ScrollManager,ScrollMemo,useScrollMemo } = mod;
export { ScrollManager,ScrollMemo,useScrollMemo };
export default mod.default ?? mod;